import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
/*
Ver documentación en: https://vuex.vuejs.org/api/#mutations
*/

const ProfilesVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "Profile/v1.0/",
    $_profiles: [],
    $_currentProfile: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allProfiles: (state) => state.$_profiles,
    currentProfile: (state) => state.$_currentProfile,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initProfile({ commit }) {
      var profile = {
        id: 0,
        name: "",
        active: false,
        roles: [],
        application: {
          id: 0
        }
      };

      commit("SET_PROFILE", profile);
    },
    clearProfiles({ commit }) {
      commit("SET_PROFILES", []);
    },
    setProfile({ commit }, profile) {
      commit("SET_PROFILE", profile);
    },
    async getProfiles({ commit, dispatch, state, rootGetters }) {
      var authUrl = rootGetters.authUrl;

      //OHG, cambio para que salgan solo los de la aplicación actual.
      //var actionLink = authUrl + state.$_moduleApiPath + "GetProfilesAsync"; // "GetProfilesByApplicationIdAsync" + ":" + rootGetters.applicationId;

      var actionLink =
        authUrl +
        state.$_moduleApiPath +
        "GetProfilesByApplicationIdQuery:" +
        rootGetters.applicationId;

      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PROFILES", response.data.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getProfile({ commit, dispatch, state, rootGetters }, id) {
      var authUrl = rootGetters.authUrl;
      var actionLink =
        authUrl + state.$_moduleApiPath + "GetProfilesByIdQuery" + ":" + id;
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_PROFILE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async createProfile({ commit, dispatch, state, rootGetters }, profile) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "CreateProfilesAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        profile.application.id = rootGetters.applicationId;
        const response = await axios.post(actionLink, profile, axiosConfig);
        profile.id = response.data.id;
        commit("SET_PROFILE", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateProfile({ commit, dispatch, state, rootGetters }, data) {
      var authUrl = rootGetters.authUrl;
      var actionLink = authUrl + state.$_moduleApiPath + "UpdateProfilesAsync";
      var axiosConfig = rootGetters.authaxiosConfig;
      try {
        data.profile.application = { id: rootGetters.applicationId };
        const response = await axios.put(actionLink, data.profile, axiosConfig);
        data.profile.id = response.data.id;
        commit("SET_PROFILE", data.profile);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_PROFILES(state, value) {
      state.$_profiles = value;
    },
    SET_PROFILE(state, value) {
      state.$_currentProfile = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default ProfilesVuexModule;
